/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempShapesCheckboxIntermediate: {
  name: 'temp-shapes-checkbox-intermediate';
  data: string;
} = {
  name: 'temp-shapes-checkbox-intermediate',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm18 0H4v16h16V4ZM6 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8Z" fill="currentColor"/></svg>`,
};
